import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { socket } from "./io";
import "./App.css";
import { useTranslation } from "react-i18next";
import Sorteo from "./components/sorteo/sorteo";
import money from './assets/raining-money-14.gif'
import Jackpot from "./components/jackpot/jackpot";
async function loadDseg() {
  const font = new FontFace("DSEG7", "url(/fonts/DSEG7Classic-Bold.woff2)");
  await font.load();
  document.fonts.add(font);
  await document.fonts.ready;
}
const rouletteColors = [
  { value: 0,  color: "green" },
  { value: 1,  color: "red" },
  { value: 2,  color: "black" },
  { value: 3,  color: "red" },
  { value: 4,  color: "black" },
  { value: 5,  color: "red" },
  { value: 6,  color: "black" },
  { value: 7,  color: "red" },
  { value: 8,  color: "black" },
  { value: 9,  color: "red" },
  { value: 10, color: "black" },
  { value: 11, color: "black" },
  { value: 12, color: "red" },
  { value: 13, color: "black" },
  { value: 14, color: "red" },
  { value: 15, color: "black" },
  { value: 16, color: "red" },
  { value: 17, color: "black" },
  { value: 18, color: "red" },
  { value: 19, color: "red" },
  { value: 20, color: "black" },
  { value: 21, color: "red" },
  { value: 22, color: "black" },
  { value: 23, color: "red" },
  { value: 24, color: "black" },
  { value: 25, color: "red" },
  { value: 26, color: "black" },
  { value: 27, color: "red" },
  { value: 28, color: "black" },
  { value: 29, color: "black" },
  { value: 30, color: "red" },
  { value: 31, color: "black" },
  { value: 32, color: "red" },
  { value: 33, color: "black" },
  { value: 34, color: "red" },
  { value: 35, color: "black" },
  { value: 36, color: "red" },
];
function App() {

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const canvasRef = useRef(null);
  const drawRef = useRef(function () {});
  const resizeFnRef = useRef(null);

  const [authorized, setAuthorized] = useState(true);

  const [timer, setTimer] = useState(180);
  const [screen, setScreen] = useState(3);
  const [jackpot, setJackpot] = useState(0);
  const [history, setHistory] = useState([]); // SIEMPRE array
  const [lastResult, setLastResult] = useState("--");
  const [Jpl, setJpl] =useState({value:'--', ticket:'--'})
    const [paidJp, setPaidJp] = useState(false);
  const [jackpotToPay, setJackpotToPay] = useState({ value: 0, type: '' });
  const [run, setRun] = useState({code:'', factor: 1})

  const [credit, setCredit] = useState(2000);
  const [betAmount, setBetAmount] = useState(50);

  // ===== Transiciones =====
  const [displayScreen, setDisplayScreen] = useState(0);
  const [phase, setPhase] = useState("in"); // "out" | "hold" | "in"
  const [sorteoReady, setSorteoReady] = useState(false);

 let FADE_MS = 260;

  // ===== Helpers =====
  const fmtValue = (v) => {
    if (v === null || v === undefined || v === "") return "--";
    return String(v);
  };

  const fmtJackpot = (v) => {
    if (v === null || v === undefined || v === "") return "--";
   let num = Number(v);
    if (!Number.isNaN(num)) {
      try {
        return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
      } catch (e) {
        return String(v);
      }
    }
    return String(v);
  };

  const bettingOpen = useMemo(() => {
   let n = Number(timer);
    if (Number.isFinite(n)) return n > 0;
    return !!timer;
  }, [timer]);

  const normalizeHistory = (arr) => {
    if (!Array.isArray(arr)) return [];
    let out = [];
    for (let i = 0; i < arr.length; i++) {
      let v = arr[i].winner;
      let factor = arr[1].factor;
      let n = Number(v);
      const code = arr[i].code.toString().padStart(6,'0')
      if (Number.isFinite(n) && n >= 0 && n <= 36) out.push({winner:n, code:code, factor});
    }
    return out;
  };

  const bgForNumber = (n) => {
    const numWin = rouletteColors.find(item => item.value==n)
    if (numWin.color ==='green') return "#0B8F4D";
    if (numWin.color ==='black') return "#000000";
    return  "#ff0415";
  };

  // =========================
  // Socket + Auth
  // =========================
  useEffect(() => {
   let user = localStorage.getItem("user");
   let level = localStorage.getItem("level");

    if (!user || level !== "4") {
      setAuthorized(false);
      window.location.replace("/login");
      return;
    }
// ACTULAIZAR JPL



    function onClosed() {
      localStorage.clear();
      window.location.replace("/");
    }

    function onTimer(val) {
      console.log('time:',val)
      if (val === null || val === undefined || val === "") return;
      setTimer(val);
    }

    function onJackpot(data) {
      if (data && data.winner && data.winner.jackpot && data.winner.jackpot.value > 0) {
        setPaidJp(true);
        setJackpotToPay({
          point: data.winner.jackpot.point,
          ticket: data.ticket,
          value: data.winner.jackpot.value,
          type: data.winner.jackpot.type,
          customer: data.winner.jackpot.customer // Asegúrate de que 'customer' exista en 'data.winner.jackpot'
        });
    }
  }

    function onCredit(val) {
      if (val === null || val === undefined || val === "") return;
      setCredit(val);
    }

    function onBetAmount(val) {
      if (val === null || val === undefined || val === "") return;
      setBetAmount(val);
    }

    function onHistory(arr) {
     let clean = arr;
      if (clean.length === 0) return;
            console.log('clean',clean.map(it=>it.factor))
      setHistory(clean);
    }


    function onRun(run) {
      console.log('run:',run)
        setRun({code:run.run.code, factor: run.run.factor.value})
      if (run && run.history) {
        socket.emit('jpl')     
        setHistory(run.history);
      }
    }

    function onScreen(scr) {
      console.log('SCR: ',scr)
     let sc = scr && typeof scr === "object" ? scr.screen : scr;
     setTimer(scr.time)
      if (sc === null || sc === undefined) return;
      setScreen(sc);
    }

    socket.on("closed", onClosed);
    socket.on("timer", onTimer);
    socket.on("jackpot", onJackpot);
    socket.on("history", onHistory);
    socket.on("run", onRun);
    socket.on("screen", onScreen);

    socket.on("credit", onCredit);
    socket.on("betAmount", onBetAmount);

    function onState(s) {
      if (!s || typeof s !== "object") return;

      if (s.run) onRun(s.run);

      if (s.screen !== undefined) onScreen(s);

      if (s.time !== undefined) onTimer(s.time);
      else if (s.timer !== undefined) onTimer(s.timer);

     let jp = null;
      if (s.jpg && typeof s.jpg === "object" && s.jpg.value !== undefined) jp = s.jpg.value;
      else if (s.jackpot !== undefined) jp = s.jackpot;
      if (jp !== null) onJackpot(jp);

      if (s.history !== undefined) onHistory(s.history);

     let lr = s.lastResult !== undefined ? s.lastResult : s.result;
      if (lr !== null && lr !== undefined && lr !== "") setLastResult(lr);

      if (s.credit !== undefined) onCredit(s.credit);
      if (s.betAmount !== undefined) onBetAmount(s.betAmount);
    }

    socket.on("state", onState);
  socket.emit('jpl')
  socket.on('jpl-from-server',(value)=>setJpl(value))
    return () => {
      socket.off("closed", onClosed);
      socket.off("timer", onTimer);
      socket.off("jackpot", onJackpot);
      socket.off("history", onHistory);
      socket.off("run", onRun);
      socket.off("screen", onScreen);

      socket.off("credit", onCredit);
      socket.off("betAmount", onBetAmount);

      socket.off("state", onState);
    };
  }, []);

  // =========================
  // Transiciones entre screens
  // =========================
  useEffect(() => {
    if (screen === null || screen === undefined) return;

    if (displayScreen === 0) {
      setDisplayScreen(screen);
      return;
    }

    if (screen === displayScreen) return;

    setPhase("out");
    setSorteoReady(false);

   let t = setTimeout(function () {
      setDisplayScreen(screen);
      if (screen === 2) setPhase("hold");
      else setPhase("in");
    }, FADE_MS);

    return () => clearTimeout(t);
  }, [screen, displayScreen]);

  // =========================
  // Canvas resize: antes del paint + eventos
  // =========================
  useLayoutEffect(() => {
    function getViewport() {
     let vv = window.visualViewport;
     let w = vv && vv.width ? Math.floor(vv.width) : Math.floor(window.innerWidth);
     let h = vv && vv.height ? Math.floor(vv.height) : Math.floor(window.innerHeight);
      return { w: w, h: h };
    }

    function resizeCanvas() {
     let canvas = canvasRef.current;
      if (!canvas) return;

     let dpr = window.devicePixelRatio || 1;
     let vp = getViewport();
     let w = vp.w;
     let h = vp.h;

      canvas.style.position = "fixed";
      canvas.style.left = "0";
      canvas.style.top = "0";
      canvas.style.width = w + "px";
      canvas.style.height = h + "px";
      canvas.style.zIndex = "10";
      canvas.style.pointerEvents = "none";

      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);

     let ctx = canvas.getContext("2d");
      if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    resizeFnRef.current = resizeCanvas;

    // 1) resize inmediato (layout effect)
    resizeCanvas();

    // 2) y un resize+draw al primer frame (arregla el “primer paint”)
    requestAnimationFrame(function () {
      resizeCanvas();
      if (drawRef.current && (displayScreen === 1 || displayScreen === 3 || displayScreen === 0)) {
        drawRef.current();
      }
    });

    // 3) y otro pequeño después (por barras/UI del navegador)
   let t = setTimeout(function () {
      resizeCanvas();
      if (drawRef.current && (displayScreen === 1 || displayScreen === 3 || displayScreen === 0)) {
        drawRef.current();
      }
    }, 120);

    window.addEventListener("resize", resizeCanvas);
    document.addEventListener("fullscreenchange", resizeCanvas);
    if (window.visualViewport) window.visualViewport.addEventListener("resize", resizeCanvas);

    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", resizeCanvas);
      document.removeEventListener("fullscreenchange", resizeCanvas);
      if (window.visualViewport) window.visualViewport.removeEventListener("resize", resizeCanvas);
    };
  }, [displayScreen]);

  // =========================
  // Dibujo canvas (ajusta a tamaño REAL del canvas)
  // =========================
  drawRef.current = function () {
    try {
     let canvas = canvasRef.current;
      if (!canvas) return;

      // IMPORTANTE: usa el tamaño interno real del canvas
     let dpr = window.devicePixelRatio || 1;
     let W = Math.floor(canvas.width / dpr);
     let H = Math.floor(canvas.height / dpr);

     let ctx = canvas.getContext("2d");
      if (!ctx) return;

      ctx.clearRect(0, 0, W, H);

      function rr(x, y, w, h, r) {
       let radius = Math.max(0, Math.min(r, Math.min(w, h) / 2));
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.arcTo(x + w, y, x + w, y + h, radius);
        ctx.arcTo(x + w, y + h, x, y + h, radius);
        ctx.arcTo(x, y + h, x, y, radius);
        ctx.arcTo(x, y, x + w, y, radius);
        ctx.closePath();
      }

      function card(x, y, w, h) {
        ctx.save();
        ctx.shadowColor = "rgba(0,0,0,0.35)";
        ctx.shadowBlur = 18;
        ctx.shadowOffsetY = 10;

        rr(x, y, w, h, 18);
        ctx.fillStyle = "rgba(12, 12, 20, 0.55)";
        ctx.fill();

        ctx.shadowBlur = 0;
        rr(x, y, w, h, 18);
        ctx.strokeStyle = "rgba(255,255,255,0.20)";
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.restore();
      }

      function text(str, x, y, size, weight, alpha, align) {
        if (weight === undefined) weight = 800;
        if (alpha === undefined) alpha = 1;
        if (align === undefined) align = "left";

        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.fillStyle = "#FFFFFF";
        ctx.font =
          String(weight) +
          " " +
          String(Math.floor(size)) +
          "px system-ui, -apple-system, Segoe UI, Roboto, Arial";
        ctx.textBaseline = "top";
        ctx.textAlign = align;
        ctx.fillText(String(str), x, y);
        ctx.restore();
      }

     let pad = 14;

      // TOP RIGHT (3 cards)
     let maxCardW = W - pad * 2;
     let cardW = Math.min(Math.floor(W * 0.20),Math.floor(H * 0.35));
     let rowH = Math.min(Math.floor(H * 0.13), Math.floor(W * 0.34));
     let gap = 12;

     let xTR = W - pad - cardW;
      if (xTR < pad) xTR = pad;

     let yTR = pad;
     let cx = xTR + cardW / 2;

     let labelSize = Math.min(Math.floor(W * 0.007),Math.floor(H * 0.020));
     let valueSizeBig = Math.min(Math.floor(W * 0.03),Math.floor(H * 0.050));

      card(W-1.2*cardW, yTR, 1.2*cardW, 1.5*rowH);
      text("JACKPOT", cx, yTR + 12, 3*labelSize, 900, 0.9, "center");

      text(fmtJackpot(Jpl.value), cx, yTR*1.5  + 4*labelSize, 1.5*valueSizeBig, 900, 1, "center");

      card(W/2-cardW, H/3, 2*cardW, 3.5*rowH);
      text(`PRÓXIMA RONDA #${run.code}`, W/2, H/3+4*gap, 3*labelSize, 900, 0.9, "center");
      text(`${Math.floor(fmtValue(timer)/60).toString().padStart(2,'0')}:${Math.floor(fmtValue(timer)%60).toString().padStart(2,'0')}`, W/2, H/2+gap, 6*valueSizeBig * 0.78, 900, 1, "center");

      card(W-1.2*cardW, yTR + 1.5*rowH + gap, 1.2*cardW, 1.5*rowH);
      text("TICKET GANADOR JACKPOT", cx, yTR + 1.5*rowH + gap + 12, 1.5*labelSize, 900, 0.9, "center");
      text(fmtValue(Jpl.ticket), cx, yTR + 1.5*rowH + gap + 12 + 4*labelSize + 8, valueSizeBig, 900, 1, "center");

      // LEFT HISTORIAL (8 items) — FIT ALWAYS
     let totalItems = 8;
     let itemsGap = 8;

     let panelW = Math.min(Math.floor(H * 0.4), Math.floor(W * 0.3));
      panelW = Math.max(Math.min(panelW, W - cardW - pad * 3)); // evita choque con cards

     let headerH = Math.min(Math.floor(H * 0.1), Math.floor(W * 0.05));

     let maxPanelH = H - pad * 2;
     let availableRowsH = maxPanelH - headerH - 16 - 16;

     let fitItemH = Math.floor((availableRowsH - (totalItems - 1) * itemsGap) / totalItems);
     let desiredItemH = Math.min(Math.floor(W / 12 * 0.95), Math.floor(H / 12 * 0.95));
     let itemH = Math.max( Math.min(desiredItemH, fitItemH));

     let panelH = headerH + 16 + totalItems * itemH + (totalItems - 1) * itemsGap + 16;

     let xL = pad;
     let yL = pad;

      card(xL, yL, panelW, panelH);
      text("HISTORIAL GANADORES", xL + panelW / 2, yL + 12, Math.min(Math.round(H * 0.03),Math.round(W * 0.02)), 900, 0.9, "center");

     let hist = Array.isArray(history) ? history : [];
     let y = yL + headerH;

for (let hist of history) {
 let item = hist ? hist : null;

 let n = item ? Number(item.winner) : null;
 let label = item ? String(item.winner) : "--";
 let factor = item ? Number(item.factor || 1) : 1;

  rr(xL + 14, y, panelW - 28, itemH, 14);
  ctx.fillStyle = "rgba(255,255,255,0.06)";
  ctx.fill();

 let badgeW = Math.min(Math.floor(itemH*1.3), Math.floor(panelW*1.3));
  rr(xL + 18, y+2, badgeW, itemH-4, 12);
  ctx.fillStyle = bgForNumber(n);
  ctx.fill();

  // winner
  ctx.save();
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "900 " + String(Math.min(Math.floor(itemH*0.9), Math.floor(panelW * 0.86))) + "px system-ui, Segoe UI, Arial";
  ctx.textBaseline = "middle";
  ctx.textAlign = "center";
  ctx.fillText(label, xL + 18 + badgeW / 2, y + itemH / 2);
  ctx.restore();

  // BONO (solo si factor > 1)
  if (item && factor > 1) {
    // colores por factor (opcional)
   let bg = "#1e40af"; // default azul
    if (factor === 2) bg = "#e204ff";       // rojo
    else if (factor === 3) bg = "#ff6c04";  // naranja
    else if (factor === 5) bg = "#0351f9";  // azul
    else if (factor === 10) bg = "#02fe5f"; // verde

   let rx = xL + panelW * 0.35;
   let ry = y + itemH*0.2;
   let rw = panelW * 0.15;
   let rh = itemH * 0.6;

    ctx.save();
    ctx.beginPath();                 // ✅ importante
    if (ctx.roundRect) ctx.roundRect(rx, ry, rw, rh, 10);
    else {
      // fallback si no existe roundRect
      rr(rx, ry, rw, rh, 10);
    }
    ctx.fillStyle = bg;              // ✅ ahora sí rellena
    ctx.fill();
    ctx.strokeStyle = "rgba(255,255,255,0.20)";
    ctx.lineWidth = 2;
    ctx.stroke();

    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.font = "900 " + String(Math.min(Math.floor(panelW * 0.04), Math.floor(itemH * 0.2))) + "px system-ui, Segoe UI, Arial";
    ctx.fillText("BONO", rx + rw / 2, y + itemH * 0.35);

    ctx.font = "900 " + String(Math.min(Math.floor(panelW * 0.08), Math.floor(itemH * 0.4))) + "px system-ui, Segoe UI, Arial";
    ctx.fillText("X" + factor, rx + rw / 2, y + itemH * 0.62);

    ctx.restore();
  }

  // code (derecha)
  ctx.save();
  ctx.fillStyle = "rgba(238, 239, 227, 0.7)";
  ctx.font = "800 " + String(Math.min(Math.floor(panelW * 0.4), Math.floor(itemH*0.6 ))) + "px system-ui, Segoe UI, Arial";
  ctx.textBaseline = "middle";
  ctx.textAlign = "right";
 let code = item ? String(item.code).padStart(2, "0") : "--";
  ctx.fillText(code, xL + panelW - 18, y + itemH / 2);
  ctx.restore();

  y += itemH + itemsGap;
}

    } catch (err) {
      // console.error("Draw error:", err);
    }
  };

  // Forzar resize+draw cuando cambian datos (y después de cambios de screen)
  useEffect(() => {
    if (resizeFnRef.current && (displayScreen === 1 || displayScreen === 3 || displayScreen === 0)) {
      resizeFnRef.current();
    }
    requestAnimationFrame(function () {
      if (drawRef.current && (displayScreen === 1 || displayScreen === 3 || displayScreen === 0)) {
        drawRef.current();
      }
    });
  }, [timer, jackpot, history, lastResult, displayScreen]);

  // =========================
  // Screen 2: quitar blanco SIN depender de onReady
  // (detecta cuando Sorteo ya insertó su canvas)
  // =========================
  const sorteoHostRef = useRef(null);

  useEffect(() => {
    if (displayScreen !== 2) return;

    setSorteoReady(false);

   let host = sorteoHostRef.current;
    if (!host) {
      setSorteoReady(true);
      return;
    }

    function check() {
      // busca cualquier canvas dentro del Sorteo
     let c = host.querySelector("canvas");
      if (c && c.width > 0 && c.height > 0) {
        // damos 1 frame extra para que pinte el primer frame
        requestAnimationFrame(function () {
          setSorteoReady(true);
        });
        return true;
      }
      return false;
    }

    if (check()) return;

   let obs = new MutationObserver(function () {
      check();
    });
    obs.observe(host, { childList: true, subtree: true });

    // respaldo por si no detecta (nunca te deja en loader infinito)
   let t = setTimeout(function () {
      setSorteoReady(true);
    }, 1500);

    return () => {
      try { obs.disconnect(); } catch (e) {}
      clearTimeout(t);
    };
  }, [displayScreen]);

  useEffect(() => {
    if (displayScreen === 2 && sorteoReady) setPhase("in");
  }, [displayScreen, sorteoReady]);

  // =========================
  // Render
  // =========================
  if (!authorized) return null;

 let content = null;

  // Canvas screens: 1 y 3 (y 0 inicial)
 let showCanvas = displayScreen === 0 || displayScreen === 1 || displayScreen === 3;

  if (displayScreen === 2) {
    content = (
      <div className="App" style={{ background:'rgba(0,0,0,0.05)', width: "100vw", height: "100vh" }}>
        {run && run.factor && run.factor>1?<div className={`bono bono${run.factor}`}>{`X${run.factor}`}</div>:<div></div>}
        <div ref={sorteoHostRef} style={{ position: "fixed", inset: 0, background: "#00000003" }}>
          <Sorteo />
        </div>

        {!sorteoReady ? (
          <div style={styles.loader}>
            loading…
          </div>
        ) : null}
      </div>
    );
  } else if (displayScreen === 4) {
    content = <div className="App">
      <div className="div-timer">
        <div className="timer-text">LA RONDA  #{run.code} INICIA EN:</div>
        <div className="timer">{timer}</div>
        </div>
      </div>;
  } else if (displayScreen === 5) {
    content = <div className="App" style={{ color: "#fff" }}><Jackpot {...jackpotToPay}/></div>;
  } else {
    content = (
      <div className="App">
        {/* mantenemos canvas montado y full-screen */}
        <canvas ref={canvasRef} className="overlay-canvas" style={{ display: showCanvas ? "block" : "none" }} />
      </div>
    );
  }

  return (
    <div className={"screen-root " + phase} style={styles.root}>
      {content}
    </div>
  );
}

const styles = {
  root: {
    position: "fixed",
    inset: 0,
    background: 'rgba(0,0,0,0.05)',
  },
  loader: {
    position: "fixed",
    inset: 0,
    display: "grid",
    placeItems: "center",
    color: "rgba(255,255,255,0.90)",
    font: "800 22px system-ui, Segoe UI, Arial",
    background: "radial-gradient(circle at center, rgba(0,0,0,0.35), rgba(0,0,0,0.35))",
    zIndex: 9999,
  },
};

export default App;
